module.exports = __webpack_public_path__ + "static/img/30010 (3).d1bb573.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30010 (3).webp
// module id = nvXP
// module chunks = 14